import request from '@/utils/request'
import { getShopId } from '@/api/shop/shopApi'

/**
 * 获取销售排行列表
 * @param {Object} params 请求参数
 * @returns {Promise} 返回Promise对象
 */
export function getSalesRankingInfo(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/mallReport/getSalesRankingInfo',
      method: 'get',
      params: {
        ...params,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}